/**
 * @generated SignedSource<<53cacff69da55f6a50b87b2cfccbd78f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TopicsPageUpdateForumDescriptionMutation$variables = {
  description?: string | null | undefined;
  forumId: string;
};
export type TopicsPageUpdateForumDescriptionMutation$data = {
  readonly updateForum: {
    readonly node: {
      readonly description: string | null | undefined;
      readonly id: string;
    };
  };
};
export type TopicsPageUpdateForumDescriptionMutation = {
  response: TopicsPageUpdateForumDescriptionMutation$data;
  variables: TopicsPageUpdateForumDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forumId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "forumId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ForumEdge",
    "kind": "LinkedField",
    "name": "updateForum",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Forum",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicsPageUpdateForumDescriptionMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "TopicsPageUpdateForumDescriptionMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "7d87d9b8e4ad2e36c34f68a7dcad7b0a",
    "id": null,
    "metadata": {},
    "name": "TopicsPageUpdateForumDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation TopicsPageUpdateForumDescriptionMutation(\n  $forumId: ID!\n  $description: String\n) {\n  updateForum(id: $forumId, input: {description: $description}) {\n    node {\n      id\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4d170323b112cc7c2d26c476b598be8";

export default node;
